module.exports = __webpack_public_path__ + "img/9788996373704.e8ac3d2e.jpg";